/*
Plywood

--moistureResistant <boolean::checkbox>
--fireRated <boolean::checkbox>
--weight <float> | lbs/sqft | (per sheet, by lbs/sqft)
--manufacturers {
  --manufacturer <Manufacturer>
  --manufacturerNumber <string>
  --computerEaseNumber <string>
}
*/
import filters from './filters'
import headers from './headers'
import form from './form'

const name = 'Plywood'
const id = '9IzyTpfDGtiIgWVZ9v9F'

export default {
  name,
  id,
  filters,
  headers,
  form
}
